import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import { useInstance, onMounted, createRef } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { scrollbarWidth } from '../position';
import { useResizeObserver } from '../../hooks/useResizeObserver';
var hasLocalStorage = typeof localStorage !== 'undefined';
export function useWidth(scrollRef, getColumns) {
  var instance = useInstance();
  var tableRef = createRef();
  var widthMap = useState({});
  var tableWidth = useState(null);
  initWidthFromStore();
  onMounted(function () {
    return checkTableWidth(true);
  });
  useResizeObserver(scrollRef, function () {
    return checkTableWidth(false);
  }, true);
  // if exist widthStoreKey, we get the default width from localStorage
  function initWidthFromStore() {
    var _instance$get = instance.get(),
      widthStoreKey = _instance$get.widthStoreKey;
    if (widthStoreKey && hasLocalStorage) {
      var data = localStorage.getItem(widthStoreKey);
      if (data) {
        try {
          var _JSON$parse = JSON.parse(data),
            map = _mapInstanceProperty(_JSON$parse),
            width = _JSON$parse.width;
          if (map) {
            widthMap.set(map);
          }
          if (width) {
            tableWidth.set(width);
          }
        } catch (e) {}
      }
    }
  }
  function storeWidth() {
    // store width if has widthStoreKey
    var _instance$get2 = instance.get(),
      widthStoreKey = _instance$get2.widthStoreKey;
    if (widthStoreKey) {
      localStorage.setItem(widthStoreKey, _JSON$stringify({
        map: widthMap.value,
        width: tableWidth.value
      }));
    }
  }
  function checkTableWidth(isMount) {
    checkColumnMinWidth(false);
    var _instance$get3 = instance.get(),
      resizable = _instance$get3.resizable,
      type = _instance$get3.type;
    if (resizable) {
      var hasBorder = type === 'grid' || type === 'border';
      var _tableWidth = tableRef.value.offsetWidth;
      var container = scrollRef.value;
      var containerWidth = container.offsetWidth + (hasBorder ? -2 : 0);
      // detect whether the table has vertical scrollbar or not
      if (container.scrollHeight > container.clientHeight) {
        containerWidth = containerWidth - scrollbarWidth();
      }
      if (_tableWidth < containerWidth) {
        tableWidth.set(isMount ? null : containerWidth);
        storeWidth();
      }
    }
  }
  function checkColumnMinWidth(isStop) {
    var shouldUpdate = false;
    getColumns().forEach(function (rowColumns) {
      rowColumns.forEach(function (column) {
        var _column$props = column.props,
          key = _column$props.key,
          minWidth = _column$props.minWidth;
        if (minWidth) {
          var width = column.children.elementRef.value.offsetWidth;
          if (width < minWidth) {
            widthMap.value[key] = minWidth;
            shouldUpdate = true;
          }
        }
      });
    });
    if (shouldUpdate) {
      // let useFixedColumns to update scroll position
      widthMap.set(_extends({}, widthMap.value));
      instance.forceUpdate(function () {
        // check again because it may affect other columns
        if (!isStop) {
          // only check one more time, because sometimes we can not fix the width of column, #473
          // e.g. table display: none;
          checkColumnMinWidth(true);
        }
      });
    }
  }
  function getWidth(key) {
    var width = widthMap.value[key];
    // if (width === 'auto') return width;
    if (width) return width + "px";
    return null;
  }
  return {
    tableRef: tableRef,
    tableWidth: tableWidth,
    widthMap: widthMap,
    storeWidth: storeWidth,
    getWidth: getWidth
  };
}